import {
    IonCol, IonContent, IonHeader, IonPage, IonRow, IonTitle, IonToolbar, useIonModal, IonSearchbar,
    IonList, IonSelect, IonItem, IonSelectOption, IonLabel, IonButton, useIonViewDidEnter, IonIcon,
    isPlatform, useIonAlert,
    useIonViewWillLeave
} from '@ionic/react';
import { Capacitor } from '@capacitor/core';
import { GoogleMap } from '@capacitor/google-maps';
import { MapType } from '@capacitor/google-maps';
import { useEffect, useRef, useState, useContext, SetStateAction, useCallback } from 'react';
import { searchOutline, closeOutline, map } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import { Geolocation } from '@capacitor/geolocation';
import { StatusBar } from '@capacitor/status-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';

import AuthContext from "../UserContext";

import './Map.css';

import { initialMarkers } from '../data/index';

import { AgentMarkerInfoWindow } from '../components/AgentMarkerInfoWindow';
import { MapClickCallbackData, MarkerClickCallbackData } from '@capacitor/google-maps/dist/typings/definitions';

import axiosCall from '../data/axios';
import { Preferences } from '@capacitor/preferences';
import { add, set } from 'date-fns';
//import { App } from '@capacitor/app';

const AgentMap: React.FC = () => {
    const baseUrl = `${process.env.REACT_APP_BASE_URL}`;
    let env = `${process.env.REACT_APP_ENVIRONMENT}`;

    const history = useHistory();
    const { authValues } = useContext(AuthContext);
    const newMap = useRef<GoogleMap | null>(null);
    const [isAgentMapReady, setIsAgentMapReady] = useState(false);
    const isMapInitializedRef = useRef(false);

    if (!authValues.authenticated)
        history.push('/login');

    const [markers, setMarkers] = useState<any[]>([]);
    const mapRef = useRef(null);
    const [selectedMarker, setSelectedMarker] = useState({});
    const [newMarkerNOMINATIM, setNewMarkerNOMINATIM] = useState({});
    const [myMarkersCheck, setMyMarkersCheck] = useState(false);
    const [presentAlert] = useIonAlert();

    //BOTTOM SHEET MODAL
    const handleDismiss = () => {
        dismiss()
    }

    const [present, dismiss] = useIonModal(AgentMarkerInfoWindow, {
        marker: selectedMarker,
        onDismiss: handleDismiss,
        setMyMarkersCheck: setMyMarkersCheck,
        authValues: authValues,
        map: newMap.current,
    });

    //MODAL CONFIGS
    const modalOptions = {
        initialBreakpoint: 1,
        breakpoints: [0.35, 0.5, 0.75, 1],
        backdropBreakpoint: 0,
        onDidDismiss: () => dismiss(),
		backdropDismiss: false
    };

    //MARKER CLICK
    const agentMarkerClick = async (marker: MarkerClickCallbackData) => {
        //console.log(marker.latitude);
        if(marker.title == "Your Location") {
            presentAlert({
                header: 'You are here!',
                subHeader: 'Your Location',
                message: 'This is your current location.',
                cssClass: 'drukre',
                buttons: ['Ok'],
            });
            return;
        }
        if (marker.title != "New Property" && markers) {
            let pickedMarker = markers.filter((m: any) => (m.slug === marker.title))[0];
            //If the marker does not match the original marker, update the lat/lng
            if(pickedMarker.latitude != marker.latitude || pickedMarker.longitude != marker.longitude) {
                pickedMarker['lat'] = marker.latitude;
                pickedMarker['lng'] = marker.longitude;
            }
            const imagePaths = pickedMarker?.photos || [];
            const imageObjects = [];
            for (let i = 0; i <= imagePaths.length; i++) {
                if (imagePaths[i]) {
                    //let image = await fetch(baseUrl + '/' + imagePaths[i]);
                    imageObjects.push({ 'src': env == 'staging' ? baseUrl + imagePaths[i]?.photo : imagePaths[i]?.photo });
                }
            }
            pickedMarker['images'] = imageObjects;
            setSelectedMarker(pickedMarker);
        }
        else {
            let newMarker = {
                'lat': marker.latitude,
                'lng': marker.longitude,
                'images': [],
                'address': 'display_name' in newMarkerNOMINATIM ? newMarkerNOMINATIM.display_name : null,
                'markerId': marker.markerId,
            };
            //if(newMarker.lat == newMarkerNOMINATIM.lat && newMarker.lng == newMarkerNOMINATIM.lng)
            setSelectedMarker(newMarker);
        }

        if(!newMap.current) return;

        newMap.current.removeMarker(marker.markerId);

        newMap.current.addMarker({
            coordinate: {
                lat: marker.latitude,
                lng: marker.longitude
            },
            title: marker.title,
            iconUrl: 'assets/icon/greencircle.png',
            iconSize: {
                width: 20,
                height: 20
            },
            draggable: true
        });
        
        present(modalOptions);
    }

    //MAP MARKER
    const addMapMarker = async (marker: any, map: GoogleMap, isNew: boolean) => {
        const mId = await map.addMarker({
            coordinate: {
                lat: marker.lat,
                lng: marker.lng
            },
            title: marker.slug ? marker.slug : marker.label, //To identify the marker when dragged & clicked
            iconUrl: isNew ? 'assets/icon/greencircle.png' : 'assets/icon/redmarker.png',
            iconSize: {
                width: isNew ? 20 : 15,
                height: isNew ? 20 : 15
            },
            draggable: isNew
        });
        marker.markerId = mId;
        return mId;
    };

    const addMapMarkers = async(passedMarkers: any, map: GoogleMap) => {
        passedMarkers.forEach((marker: any) => addMapMarker(marker, map, false));
        return passedMarkers;
    }

    //FETCH LISTINGS
    const fetchListings = async () => {
        if (!myMarkersCheck) {
            let myListings: any[] = [];
            axiosCall("/api/listing/manage", 'get', null, true)
                .then((res) => {
                    let listings = res.data.listings;
                    listings.forEach((listing: any) => {
                        listing.lat = Number(listing.latitude);
                        listing.lng = Number(listing.longitude);
                        myListings.push(listing);
                    });
                    setMarkers(myListings);
                    setMyMarkersCheck(true);
                })
                .catch((error) => {
                    //setIserror(true);
                    setMyMarkersCheck(true);
                });
        }
    };

    // Set default zoom level based on the screen size
    let defaultZoom = 9; // fallback
    if (window.innerWidth < 600) {
        defaultZoom = 7; // smaller zoom for mobile
    } else if (window.innerWidth < 1200) {
        defaultZoom = 8; // medium zoom for tablets
    } else {
        defaultZoom = 9; // larger zoom for desktop
    }

    const [mapZoom, setMapZoom] = useState(defaultZoom);
    //MAP CONFIG
    const [mapConfig, setMapConfig] = useState({
        zoom: mapZoom,
        center: {
            lat: 27.4504392,
            lng: 89.658013
        },
        mapTypeId: 'satellite'
    });

    const createAgentMap = useCallback(async () => {
        if (!mapRef.current || newMap.current) return;
        try{
            console.log('****Creating map****');
            isMapInitializedRef.current = true;
            let theMap = await GoogleMap.create({
                id: 'agent-map',
                element: mapRef.current,
                apiKey: `${process.env.REACT_APP_GMAP_KY}`,
                config: mapConfig
            });
            if (!theMap) {
                throw new Error('Map creation failed');
            }
            // Wait for map to fully initialize
            await new Promise(resolve => setTimeout(resolve, 2000));
            // Only set map type on non-iOS platforms
            //if (isPlatform('capacitor') && !isPlatform('ios')) {
                await theMap.setMapType(MapType.Hybrid);
            //}
            await theMap.setOnMapClickListener((clickedData) => mapClick(clickedData, theMap));
            theMap.setOnMarkerDragEndListener(async (marker) => {
                let isValid = await validateMarker({ 'lat': marker.latitude, 'lng': marker.longitude });
                if (isValid != true)
                    theMap.removeMarker(marker.markerId);
            });
            newMap.current = theMap;
            setIsAgentMapReady(true);
        } catch (error) {
            console.error('Error creating map:', error);
            alert('Error creating map');
        }
    }, []);

    // Define the country's boundaries (example: Bhutan)
    const countryBounds = {
        north: 28.246987,
        south: 26.702016,
        west: 88.746472,
        east: 92.125232
    };

    const setMapCamera = async (mrkrs: any) => {
        try {
            const position = await Geolocation.getCurrentPosition();
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;

            // Check if the user's location is within the country's boundaries
            if (newMap.current) {
                if (
                    userLat >= countryBounds.south &&
                    userLat <= countryBounds.north &&
                    userLng >= countryBounds.west &&
                    userLng <= countryBounds.east
                ) {
                    newMap.current.setCamera({
                        coordinate: {
                            lat: userLat,
                            lng: userLng
                        },
                        animate: true,
                    });
                } else {
                    newMap.current.setCamera({
                        coordinate: {
                            lat: mrkrs[0]?.lat || 27.237195,
                            lng: mrkrs[0]?.lng || 89.747277
                        },
                        animate: true,
                    });
                }
            }
        } catch (error) {
            console.error('Error getting user location:', error);
        }
    };

    useEffect(() => {
        if (newMap.current) {
            // Clear existing markers
            //newMap.current.clearMarkers();
            newMap.current.setOnMarkerClickListener((marker) => agentMarkerClick(marker));

            // Add new markers
            addMapMarkers(markers, newMap.current);
            setMapCamera(markers);
            newMap.current.enableClustering();
            newMap.current.setOnClusterClickListener((cl) => {
                console.log('MapZoom: ' + mapZoom);
                setMapZoom(prevZoom => {
                    const zoomIncrement = prevZoom + 1; 
                    if (newMap.current) {
                        newMap.current.setCamera({
                            zoom: zoomIncrement,
                            coordinate: {
                                lat: cl.latitude,
                                lng: cl.longitude
                            },
                            angle: 0,
                            animate: true,
                            animationDuration: 2
                        });
                    }
                    return zoomIncrement;
                })
                if (!newMap.current) return;
                newMap.current.setCamera({
                    zoom: defaultZoom,
                    coordinate: {
                        lat: cl.latitude,
                        lng: cl.longitude
                    },
                    angle: 0,
                    animate: true,
                    animationDuration: 2
                });
            });

            //RESET ZOOM WHEN ZOOMED OUT
            newMap.current.setOnBoundsChangedListener(async () => {
                if (!newMap.current) return;
                const bounds = await newMap.current.getMapBounds();
                // Calculate the latitude and longitude span
                const latSpan = Math.abs(bounds.northeast.lat - bounds.southwest.lat);
                const lngSpan = Math.abs(bounds.northeast.lng - bounds.southwest.lng);

                // Set your own threshold for "zoomed out" (adjust as needed)
                const LAT_THRESHOLD = 5;
                const LNG_THRESHOLD = 5;

                if (latSpan > LAT_THRESHOLD || lngSpan > LNG_THRESHOLD) {
                    setMapZoom(defaultZoom);
                }
            });
        }
    }, [markers, isAgentMapReady, newMap.current]);

    useIonViewDidEnter(() => {
        if(!authValues.authenticated) {
            history.push('/login');
            return;
        }

        // Disable status bar for map page
        const disableEdgeToEdge = async () => {
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
                try {
                    await StatusBar.hide();
                    await EdgeToEdge.disable();
                    console.log('Edge-to-edge mode disabled for map page');
                } catch (error) {
                    console.error('Error disabling edge-to-edge mode:', error);
                }
            }
        };
        disableEdgeToEdge();

        if(!isMapInitializedRef.current)
            createAgentMap();
        if (`${process.env.REACT_APP_ENVIRONMENT}` == 'development') {
            setMarkers(initialMarkers);
            setMyMarkersCheck(true);
        } else {
            fetchListings();
            return;
        }
    });

    useEffect(() => {
        if (myMarkersCheck) return;
        fetchListings();
    }, [myMarkersCheck]);

    useIonViewWillLeave(() => {

        // Handle async operations without making the callback async
        const cleanupEdgeToEdge = async () => {
            // Re-enable edge-to-edge mode when leaving map page
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
                try {
                    await StatusBar.show();
                    await EdgeToEdge.enable();
                    console.log('Edge-to-edge mode enabled when leaving map page');
                } catch (error) {
                    console.error('Error enabling edge-to-edge mode:', error);
                }
            }
        };
        
        // Call the async function but don't await it in the callback
        cleanupEdgeToEdge();

        if (newMap.current) {
            newMap.current.destroy();
            newMap.current = null;
            setMyMarkersCheck(false);
            setIsAgentMapReady(false);
            isMapInitializedRef.current = false;
        }
    });

    const mapClick = async (newData: MapClickCallbackData, map: GoogleMap) => {
        let newMarker = { 'lat': newData.latitude, 'lng': newData.longitude, 'label': 'New Property' };
        let isValid = await validateMarker(newMarker);
        if (isValid == true)
            addMapMarker(newMarker, map, true);
    }

    async function validateMarker(vMarker: any) {
        let result = await axiosCall('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' +
            vMarker.lat + '&lon=' + vMarker.lng, 'get')
            .then((res: any) => {
                if (res.data.address.country != 'Bhutan') {
                    presentAlert({
                        header: 'Alert!',
                        subHeader: 'Unsupported Marker',
                        message: 'You marked a location that is not supported!',
                        cssClass: 'drukre',
                        buttons: ['Ok'],
                    });
                    return false;
                }
                else {
                    //setNewMarkerNOMINATIM(res.data);
                    return true;
                }
            })
            .catch((error: any) => {
                console.log(error);
                return false;
            });
        return result;
    }
    const viewMyLocation = async () => {
        if (newMap.current) {
            const position = await Geolocation.getCurrentPosition();
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;

            let myLocMarkerID = await newMap.current.addMarker({
                coordinate: {
                    lat: userLat,
                    lng: userLng
                },
                title: 'Your Location',
                iconUrl: 'assets/icon/userlocation.png'
            });
            // Remove marker after 60 seconds
            setTimeout(() => {
                if (newMap.current && myLocMarkerID) {
                    newMap.current.removeMarker(myLocMarkerID);
                }
            }, 60000);
            
            // Check if the user's location is within the country's boundaries
            if (
                userLat >= countryBounds.south &&
                userLat <= countryBounds.north &&
                userLng >= countryBounds.west &&
                userLng <= countryBounds.east
            ) {
                newMap.current.setCamera({
                    coordinate: {
                        lat: userLat,
                        lng: userLng
                    },
                    animate: true,
                });
                
            } else {
                presentAlert({
                    header: 'Alert!',
                    subHeader: 'Unsupported Location',
                    message: 'Your location is outside the supported area! You can see by zooming out the map.',
                    cssClass: 'drukre',
                    buttons: ['Ok'],
                });
            }
        } else {
            presentAlert({
                header: 'Error',
                message: 'Map is not initialized yet.',
                cssClass: 'drukre',
                buttons: ['Ok'],
            });
        }
    }

    // Add this function to your Map component
    const requestLocationPermission = async () => {
        try {
            if (Capacitor.isNativePlatform()) {
                // Your existing native platform code
                const permissionStatus = await Geolocation.checkPermissions();
                
                if (permissionStatus.location === 'granted') {
                    viewMyLocation();
                } 
                else if (permissionStatus.location === 'denied') {
                    // Show settings dialog for native platforms
                    presentAlert({
                        header: 'Location Access Required',
                        message: 'This app needs access to your location. Please enable location permissions in your device settings.',
                        buttons: [
                            { text: 'Cancel', role: 'cancel' },
                            {
                                text: 'Open Settings',
                                handler: async () => {
                                    if (Capacitor.getPlatform() === 'ios') {
                                        //Capacitor.Plugins.App.openUrl('app-settings:');
                                    } else if (Capacitor.getPlatform() === 'android') {
                                        //Capacitor.Plugins.App.openUrl('package:' + Capacitor.Plugins.App.getInfo().id);
                                    }
                                }
                            }
                        ]
                    });
                } 
                else {
                    // First time request for native
                    const requestResult = await Geolocation.requestPermissions();
                    if (requestResult.location === 'granted') {
                        viewMyLocation();
                    } else {
                        presentAlert({
                            header: 'Location Access Denied',
                            message: 'Unable to show your location without permission.',
                            buttons: ['OK']
                        });
                    }
                }
            } else {
                // Web browser handling
                try {
                    // For browsers, just try to get the position
                    // This will automatically trigger the permission prompt if needed
                    await viewMyLocation();
                } catch (error) {
                    // Check if it's a permission error
                    if (typeof error === 'object' && error !== null && 'code' in error && (error as any).code === 1) { // PERMISSION_DENIED
                        presentAlert({
                            header: 'Location Access Denied',
                            message: 'Please allow location access in your browser settings. You may need to click the location icon in your address bar or refresh and try again.',
                            buttons: ['OK']
                        });
                    } else {
                        presentAlert({
                            header: 'Error',
                            message: 'Could not get your location: ' + (typeof error === 'object' && error !== null && 'message' in error ? (error as any).message : String(error)),
                            buttons: ['OK']
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Error requesting location permission:', error);
            presentAlert({
                header: 'Error',
                message: 'Could not request location permissions.',
                buttons: ['OK']
            });
        }
    };

    return (
        <IonPage className="mapView">
            <IonHeader>
                <IonToolbar>
                    <IonTitle> </IonTitle>
                </IonToolbar>
                { Capacitor.isNativePlatform() ? (
                    <>
                        <IonRow className="ion-center ion-justify-content-center">
                            <IonButton color="light" onClick={() => newMap.current?.setMapType(MapType.Satellite)}>
                                Satellite
                            </IonButton>
                            <IonButton color="light" onClick={() => newMap.current?.setMapType(MapType.Normal)}>
                                Normal
                            </IonButton>
                            <IonButton color="light" onClick={() => requestLocationPermission()}>
                                My location
                            </IonButton>
                        </IonRow>
                    </>
                ) : (
                    <IonRow className="ion-center ion-justify-content-center">
                        <IonButton color="light" onClick={() => requestLocationPermission()}>
                            See my location
                        </IonButton>
                    </IonRow>
                )}
            </IonHeader>
            <IonContent fullscreen>
                <IonRow>
                    <IonCol size="12">
                        <capacitor-google-map ref={mapRef} id="agent-map"></capacitor-google-map>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    )
}

export default AgentMap;